module.exports = __webpack_public_path__ + "static/img/10.4f04cc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/10.png
// module id = BsoY
// module chunks = 0